import { IApiRequestConfig } from '../api.types';

export const getMyCalendarsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getMyCalendars',
  uri: 'json',
  action: 'getMyCalendars',
  method: 'get',
});
